export const checkOutlinedIcon =
  '<svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium" style="fill: rgb(0, 191, 54);" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="CheckOutlinedIcon"><path d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"></path></svg>';
